export default "__VITE_ASSET__VcsDdCg___"